import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import { PlayerPaymentMethod } from "@/services/bedrock/dtos/PlayerPaymentMethod";

const PLAYER_PAYMENT_METHODS_SERVICE = `${Constants.API_URL}/bedrock/player_payment_methods`;

export class PlayerPaymentMethodServices {
  @scCatchServiceException()
  static async getPlayerPaymentMethods(): Promise<PlayerPaymentMethod[]> {
    const { data } = await axios.get<PlayerPaymentMethod[]>(PLAYER_PAYMENT_METHODS_SERVICE);
    return data;
  }
}
